import { ChangeEvent, useEffect, useState } from 'react';
import { Input } from '../../../components/Form/Input';
import { useAuthStore } from '../../auth/authStore';
import { useModalStore } from '../../../shared/store/uiStore';
import { createCategory, updateCategory } from '../categories.action';
import { useCategoriesStore } from '../categories.store';

interface Props {
  id?: string;
  query?: string;
}

const CategoryForm = ({ id, query = '' }: Props) => {
  const user = useAuthStore((state) => state.auth);
  const [formData, setFormData] = useState({
    name: '',
    color: '#000000',
  });
  const { closeModal } = useModalStore((state) => state);

 const categoryData = useCategoriesStore.getState().items[id || ''];

  useEffect(() => {
    setFormData({
      name: id && categoryData ? categoryData.name : query,
      color: id && categoryData ? categoryData.color : '#000000',
    });
  }, [categoryData, id, query]);

  if (!user) return null;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (id && categoryData && categoryData.name !== formData.name) {
      try {
        await updateCategory({ ...categoryData, name: formData.name, color: formData.color });
      } catch {
        throw new Error("Can't update Category.")
      }
    } else if (!categoryData) {
      try {
        await createCategory({ name: formData.name, color: formData.color, ownerId: user.uid });
      } catch {
        throw new Error("Unable to create Category")
      }
    }

    closeModal()
  };
  return (
    <form
      className='flex flex-col gap-4 mx-auto justify-center items-center'
      id='category-form'
      onSubmit={handleSubmit}
    >
      <div className='flex gap-4 w-full'>
        <Input
          name='name'
          value={formData.name}
          onChange={handleChange}
          label='Category Name'
          className='w-full'
          placeholder='Category A'
        />
        <Input
          name='color'
          onChange={handleChange}
          value={formData.color}
          label='Color'
          type='color'
          className='h-9 w-9'
          width='w-1/4'
          variant='color'
        />
      </div>
    </form>
  );
};
export default CategoryForm;
